const imageActionNames = {
  your_look: 'image_your_look',
  alternate: 'image_bag_overhead',
  overhead: 'image_bag_overhead',
  mannequin: 'image_bag_mannequin',
  back: 'image_bag_back',
  style_card: 'image_stylecard',
  flat: 'image_front_flat',
  alternate2: 'image_back_flat',
  alternate_2: 'image_back_flat',
  alternate3: 'image_detail_flat',
  alternate_3: 'image_detail_flat',
  figure_front: 'image_front_figure',
  figure_back: 'image_back_figure',
  figure_left: 'image_left_figure',
  figure_right: 'image_right_figure',
  figure_detail: 'image_detail_figure',

  // Shop Product categories
  figure: 'image_figure',
  figure_handled: 'image_figure_handled',
  flat_front: 'image_front_flat',
  flat_back: 'image_back_flat',
  flat_detail: 'image_detail_flat',
  flat_detail_bonus: 'image_flat_detail_bonus',
  flat_open: 'image_flat_open',
  flat_open_detail: 'image_flat_open_detail',
  flat_open_detail_bonus: 'image_flat_open_detail_bonus',
  flat_bonus: 'image_flat_bonus',
  flat_bottom: 'image_flat_bottom',
};

export default imageActionNames;
